import { ProductError, ProductErrorType } from '../../models';

export class PuzzleData {
  orderedPropositions: string[];
  chosenPropositions: string[];
  duration?: string;

  constructor(game: PuzzleData) {
    if (!game) {
      this.orderedPropositions = [];
      this.chosenPropositions = [];
    } else {
      this.orderedPropositions = game.orderedPropositions;
      this.chosenPropositions = game.chosenPropositions;
    }
  }

  static validate(puzzleData: PuzzleData): ProductError[] {
    const errors: ProductError[] = [];

    if (puzzleData.orderedPropositions.length < 2) {
      errors.push({
        type: ProductErrorType.NOT_ENOUGH_VALUE,
        property: 'orderedPropositions',
        payload: { message: 'You must at least add 2 propositions' },
      });
    }

    if (puzzleData.orderedPropositions.length > 12) {
      errors.push({
        type: ProductErrorType.TOO_MUCH_VALUES,
        property: 'orderedPropositions',
        payload: { message: 'You added more than 12 propositions' },
      });
    }
    puzzleData?.orderedPropositions
      ?.filter(p => !p)
      ?.forEach((p, propositionIndex) =>
        errors.push({
          type: ProductErrorType.MISSING,
          property: 'orderedPropositions',
          payload: { propositionIndex },
        }),
      );
    puzzleData?.orderedPropositions
      ?.filter(p => p.length > 150)
      ?.forEach((p, propositionIndex) =>
        errors.push({
          type: ProductErrorType.BAD_FORMAT,
          property: 'orderedPropositions',
          payload: { propositionIndex },
        }),
      );

    return errors;
  }
}

export class PuzzleProposition {
  index: number;
  text: string;
  isValid: boolean | null = null;
}
